module.exports = __webpack_public_path__ + "static/media/icomoon.e794912a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/icomoon.svg?v1g914
// module id = 249
// module chunks = 0